import { TOffer } from "types/offers-temporary";
import { LEGACY_OFFER_IMAGE_BASE_URL, OFFER_IMAGE_BASE_URL } from "config/runtime";

/**
 * Check if an offer has any uploaded image (bg or logo)
 */
export const hasOfferImage = (offer: TOffer): boolean => {
  const bg = offer.graphic?.bg;
  const logo = offer.graphic?.logo;
  // Has image if at least one of bg/logo is a non-empty string
  return !!(bg && bg.trim()) || !!(logo && logo.trim());
};

/**
 * Get the correct image URL for an offer
 * Uses local storage if available, falls back to legacy external URL
 */
export const getOfferImageUrl = (offer: TOffer, type: 'bg' | 'logo'): string => {
  const graphicPath = type === 'bg' ? offer.graphic?.bg : offer.graphic?.logo;
  
  if (graphicPath && graphicPath.includes('data/offer-images/')) {
    const filename = graphicPath.split('/').pop();
    return `${OFFER_IMAGE_BASE_URL}/offers/images/${filename}`;
  }
  
  // Fallback to legacy external URL
  return `${LEGACY_OFFER_IMAGE_BASE_URL}/${offer.graphicFolder}/${type}.png`;
};



